import { RootState } from 'app/store'
import ErrorCode from 'enums/ErrorCode'

export const selectV4ScheduledReportInfo = (state: RootState) =>
  state.scheduledReport.reportInfo.data

export const selectIsSubscribeModalOpen = (state: RootState) =>
  state.scheduledReport.subscribe.isModalOpen &&
  state.scheduledReport.subscribe.type === 'subscribe'

export const selectIsSubscribeStatusLoading = (state: RootState) =>
  state.scheduledReport.subscribe.status === 'loading'

export const selectIsUnsubscribeModalOpen = (state: RootState) =>
  state.scheduledReport.subscribe.isModalOpen &&
  state.scheduledReport.subscribe.type === 'unsubscribe'

export const selectIsScheduledReportConfigModalOpen = (state: RootState) =>
  state.scheduledReport.isConfigModalOpen

export const selectIsQuotaExceedMofalOpen = (state: RootState) =>
  state.scheduledReport.savingInfo.statusCode ===
  ErrorCode.PERMISSION_DENIED_UNSUFFICIENT_ALERT_QUOTA
